import {Component, DoCheck, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ChannelConfig, EditPermissions, NodeBuilder, NodeFlowDetails,} from '../../../../../../../shared/models';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {swalMini} from '../../../../../../../shared/utils/utils';
import {
    COLLAPSE_EXPAND_GROUPS_STATE,
    COLLAPSE_EXPAND_STATE,
    COLLAPSE_GROUPS_TOOLTIP_MESSAGE,
    COLLAPSE_TOOLTIP_MESSAGE,
    MultipleChoiceFormType,
    MultipleChoiceNode
} from './multipleChoice';
import {MatAccordion} from '@angular/material/expansion';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {MatDialog} from '@angular/material/dialog';
import {FlowManagerService} from '../../../../../services/flow-manager.service';
import {Subscription} from 'rxjs';
import {
    DISPLAY_TYPE_INDEX_LIMIT,
    displayTypeChannels,
    DisplayTypeModalData
} from '../../templates/display-type-dialog/displayTypeUtils';
import {DisplayTypeService} from '../../../../../services/display-type.service';
import {ActiveFormService} from '../../../../../services/active-form.service';
import {DeleteGroupModalComponent} from '../../../../delete-group-modal/delete-group-modal.component';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import {FlowBuilderService} from "../../../../../services/flowBuilder/flow-builder.service";

const NODE_TYPE = 'multipleChoice';

@Component({
    selector: 'app-multiple-choice',
    templateUrl: './multiple-choice.component.html',
    styleUrls: ['./multiple-choice.component.scss']
})
export class MultipleChoiceComponent extends NodeBuilder implements OnInit, OnDestroy, DoCheck {

    readonly KEYWORD_FIELD = {
        dataType: 'keyword',
        type: 'chips',
        label: '',
        placeholder: 'Add keyword(s)',
        validators: {
            maxLength: 5,
            duplicate: true,
        },
    };

    readonly DISPLAY_TYPE_LIMIT_WARNING = {
        button: 3,
        list: 10
    };

    displayIndex = DISPLAY_TYPE_INDEX_LIMIT;
    optionSeperatorList: string[] = ['. ', '- '];
    channelDisplayType = '';
    toolTipText = '';
    supportedChannels = displayTypeChannels;
    warningCondition: boolean;
    stepUniqueID: string = '';
    collapseExpandTooltip: string = COLLAPSE_TOOLTIP_MESSAGE.COLLAPSED;
    collapseExpandState: string = COLLAPSE_EXPAND_STATE.OPEN;
    channelDisplayTypeConfig = DISPLAY_TYPE_INDEX_LIMIT;
    channelConfig: ChannelConfig[];
    currentLogicOption: number = Number.MAX_SAFE_INTEGER;

    collapseExpandGroupsTooltip: string = COLLAPSE_GROUPS_TOOLTIP_MESSAGE.COLLAPSED;
    collapseExpandGroupsState: string = COLLAPSE_EXPAND_GROUPS_STATE.OPEN;

    optionCount = 0;

    // FormGroups
    menuParams: FormGroup = undefined;
    menuOptions: FormGroup = undefined;
    menuGroups: FormArray = undefined;

    // Data From DELEGATOR
    nodeFlowDetails: NodeFlowDetails;
    canEdit: EditPermissions;

    @ViewChild('GroupsAccordion') groupsAccordion: MatAccordion;
    private channelSubscription: Subscription;
    allChannelConfig: ChannelConfig[];

    optionsStartCount: number[] = [0];

    collapseExpandStates: string[] = [];
    displayTypeModalData: DisplayTypeModalData = undefined;

    constructor(
        public dialog: MatDialog,
        private flowManagerService: FlowManagerService,
        private displayService: DisplayTypeService,
        private formBuilder: FormBuilder,
        private activeFormService: ActiveFormService,
        private flowBuilder: FlowBuilderService) {
        super(NODE_TYPE);
    }

    ngOnInit(): void {
    }

    ngDoCheck() {
        this.setOptionsStartCount();
    }

    ngOnDestroy(): void {
        this.channelSubscription?.unsubscribe();
        this.activeFormService.clearFocus();
    }

    get getStepData(): {} {
        const menuParams = this.menuParams.getRawValue();
        const menuOptions: any = this.menuOptions.getRawValue();
        const menuGroups: any = this.menuGroups.getRawValue();

        const multipleChoiceNode = new MultipleChoiceNode(this.nodeType);

        multipleChoiceNode.addInput(menuParams.varName);
        multipleChoiceNode.addMenuDetails(menuParams.menuHeader, menuParams.imageRef, menuParams.bodyText);
        multipleChoiceNode.addMenuParams(menuParams.displayType, menuParams.multipleGroups, menuParams.optionSeperator, menuParams.groupTitle, menuParams.multipleSelection, menuParams.customListButton, menuParams.default);

        menuParams.multipleGroups === true
            ? multipleChoiceNode.addMenuGroups(menuGroups)
            : multipleChoiceNode.addMenuOptions(menuOptions, menuParams.multipleSelection, menuParams.groupTitle);

        const nodeData = multipleChoiceNode.nodeData;
        nodeData['next'] = menuParams.next;
        if(this.stepUniqueID !== '') {
            nodeData['metadata'].stepUniqueID = this.stepUniqueID;
        }
        return nodeData;
    }

    setOptionsStartCount() {
        if (this.menuGroups) {
            const optionsStartCount = [0];
            const formData = this.menuGroups.getRawValue();
            formData.map((group, index) => {
                if (optionsStartCount.length === 1 && index === 0) {
                    optionsStartCount.push(group.items.length);
                } else if (optionsStartCount.length === index + 1) {
                    optionsStartCount.push(optionsStartCount[index] + group.items.length);
                }
            });
            this.optionsStartCount = optionsStartCount;
        }
    }

    getOptionCount(): number {
        if (this.menuParams.value.multipleGroups && this.menuGroups) {
          return this.countGroupOptions();
        } else if (this.menuOptions && this.menuOptions.value.items) {
          return this.menuOptions.value.items.length;
        }

        return 0;
    }

  private countGroupOptions() {
    let count = 0;
    for (const menuGroup in this.menuGroups.controls) {
      count += this.menuGroups.get(`${menuGroup}.items`).value.length;
    }
    return count;
  }

  addOption(form): void {
        form.push(MultipleChoiceNode.getOptionsTemplate(this.canEdit));
        this.optionCount = this.getOptionCount();
        this.getLogicWarning();
    }

    addOptionsToTheGroups(e) {
        const groups = this.menuGroups.getRawValue();
        if (e.checked) {
            if (groups && groups.length === 1) {
                groups[0] = this.menuOptions.getRawValue();
                this.buildGroupsForm({
                    menuGroups: groups
                });
            }
        } else if (groups) {
            const items = [];
            const disabledItems = [];
            map(groups, (group) => {
                map(group.items, item => {
                    items.push(item);
                });
                map(group.disabledItems, item => {
                    disabledItems.push(item);
                });
            });
            this.buildOptionsForm({
               menuParams: this.menuParams.getRawValue(),
               menuOptions: {
                   items,
                   disabledItems
               }
            });
        }
    }

    removeOption(index: number, form: any, disabled?: boolean): void {
        if (form.length === 1 && !disabled) {
            swalMini({title: 'At least one option needed', type: 'error'});
            return;
        }
        if (!this.canEdit.canEdit) {
            return;
        }
        form.removeAt(index);
        this.optionCount = this.getOptionCount();
        this.getLogicWarning();
    }

    get isNodeValid(): boolean {
        this.menuOptions.markAllAsTouched();
        this.menuParams.markAllAsTouched();
        this.menuGroups.markAllAsTouched();
        if (this.menuParams.value && this.menuParams.value.multipleGroups && this.menuParams.value.multipleGroups === true) {
            return this.menuGroups.valid && this.menuParams.valid;
        }
        return this.menuOptions.valid && this.menuParams.valid;
    }

    set buildForm(stepData: any) {
        this.stepUniqueID = stepData.metadata?.stepUniqueID ? stepData.metadata?.stepUniqueID : '';
        const formData: MultipleChoiceFormType = MultipleChoiceNode.toForm(stepData);
        this.buildMenuParamsForm(formData);
        this.buildGroupsForm(formData);
        this.buildOptionsForm(formData);

        this.setOptionsStartCount();
    }

    buildMenuParamsForm(formData) {
        this.menuParams = MultipleChoiceNode.getMenuTemplate(this.canEdit);
        this.menuParams.patchValue(formData.menuParams);
        if (!this.optionSeperatorList.includes(formData.menuParams.optionSeperator)) {
            this.optionSeperatorList.push(formData.menuParams.optionSeperator);
        }
    }

    buildOptionsForm(formData) {
        this.menuOptions = new FormGroup({
            items: new FormArray([]),
            disabledItems: new FormArray([])
        });
        this.setDisplayType(formData.menuParams.displayType, formData.menuParams.customListButton);

        this.addOptionToForm(this.menuOptions.controls.items, formData.menuOptions.items);
        this.addOptionToForm(this.menuOptions.controls.disabledItems, formData.menuOptions.disabledItems);
    }

    buildGroupsForm(formData) {
        this.menuGroups = new FormArray([]);
        for (const group in formData.menuGroups) {
            this.addGroup();
        }
        this.menuGroups.patchValue(formData.menuGroups);
        this.menuGroups.controls.map((group, groupIndex) => {
            const groupItem = group as FormGroup;

            this.addOptionToForm(groupItem.controls.items, formData.menuGroups[groupIndex].items);
            this.addOptionToForm(groupItem.controls.disabledItems, formData.menuGroups[groupIndex].disabledItems);
        });
    }

    addOptionToForm(options, data) {
        const optionsArr = options as FormArray;
        while (optionsArr.length !== 0) {
            optionsArr.removeAt(0);
        }
        if (data) {
            for (const option in data) {
                this.addOption(options);
            }
            options.patchValue(data);
            this.addKeywords(options, data);
        }
    }

    addKeywords(form, data) {
        form.controls.map((option, index) => {
            const optionItem = option as FormGroup;
            const keywords = optionItem.controls.keywords as FormArray;
            while (keywords.length !== 0) {
                keywords.removeAt(0);
            }
            const keywordsData = data[index].keywords;
            keywordsData.map(o => {
                keywords.push(this.formBuilder.control(o));
            });
        });
    }

    /**
     *
     * @param nodeDisplayType The current displayType config -> 'number' || {8, 'NUMBER', 13: 'LIST'}
     * @param nodeCustomListButton The current customListButton -> 'string' || Options
     * @private Gets all the channels that are configured for this client and sets the new displayType structure
     */
    private setDisplayType(nodeDisplayType: {}, nodeCustomListButton: string) {
            const displayType = nodeDisplayType ? nodeDisplayType : {};
            const customListButton = nodeCustomListButton ? nodeCustomListButton : "";
            this.displayTypeModalData = {
                isDirty: false,
                displayType,
                customListButton
            }
            if (!isEmpty(displayType)) {
                this.patchDisplayType(this.displayTypeModalData);
            }
    }

    displayChange(event) {
        this.activeFormService.setActiveForm(this.menuParams);
        this.patchDisplayType(event);
        this.getLogicWarning();
    }

    private patchDisplayType(event) {
        const displayTypeFormGroup: FormGroup = this.menuParams.get('displayType') as FormGroup
        for (const channelId in event?.displayType) {
            const displayTypeValue = event?.displayType[channelId]
            if (displayTypeFormGroup.get(channelId)) {
                displayTypeFormGroup.get(channelId).setValue(displayTypeValue)
            } else {
                displayTypeFormGroup.addControl(channelId, new FormControl(displayTypeValue));
            }
        }
        if(event.isDirty) {
          displayTypeFormGroup.markAsDirty();
        }
        this.menuParams.get('customListButton').setValue(event?.customListButton);
    }

    getLogicWarning() {
        const data = this.displayService.getLogicWarning(this.optionCount, this.menuParams.get('displayType').value);
        this.toolTipText = data.toolTipText;
        this.channelDisplayType = data.options;
        this.warningCondition = data.condition;
    }

    addSeparator(e, valueInput): void {
        e.stopPropagation();
        if (valueInput !== '') {
            this.optionSeperatorList.push(valueInput);
        }
    }

    collapseExpandLogic(id: number, accordion: MatAccordion): void {
        const groupId = 'group_' + id;
        const options = document.getElementById(groupId).getElementsByClassName('mat-expansion-indicator');
        if (this.collapseExpandStates[id] === COLLAPSE_EXPAND_STATE.OPEN) {
            for(let i = 0; i < options.length; i++) {
                let element:HTMLElement =  options[i] as HTMLElement;
                if(element.attributes["style"].value.includes('180deg')) {
                    element.click();
                }
            }
            this.collapseExpandTooltip = COLLAPSE_TOOLTIP_MESSAGE.EXPANDED;
            this.collapseExpandStates[id] = COLLAPSE_EXPAND_STATE.CLOSE;
            return;
        }
        if (this.collapseExpandStates[id] === COLLAPSE_EXPAND_STATE.CLOSE) {
            for(let i = 0; i < options.length; i++) {
                let element:HTMLElement =  options[i] as HTMLElement;
                if(!element.attributes["style"].value.includes('180deg')) {
                    element.click();     
                }
            }
            this.collapseExpandTooltip = COLLAPSE_TOOLTIP_MESSAGE.COLLAPSED;
            this.collapseExpandStates[id] = COLLAPSE_EXPAND_STATE.OPEN;
            return;
        }
    }

    collapseExpandGroups(): void {
        if (this.collapseExpandGroupsState === COLLAPSE_EXPAND_GROUPS_STATE.OPEN) {
            this.groupsAccordion.closeAll();
            this.collapseExpandGroupsTooltip = COLLAPSE_GROUPS_TOOLTIP_MESSAGE.EXPANDED;
            this.collapseExpandGroupsState = COLLAPSE_EXPAND_GROUPS_STATE.CLOSE;
            return;
        }

        if (this.collapseExpandGroupsState === COLLAPSE_EXPAND_GROUPS_STATE.CLOSE) {
            this.groupsAccordion.openAll();
            this.collapseExpandGroupsTooltip = COLLAPSE_GROUPS_TOOLTIP_MESSAGE.COLLAPSED;
            this.collapseExpandGroupsState = COLLAPSE_EXPAND_GROUPS_STATE.OPEN;
            return;
        }
    }

    dropped(event: CdkDragDrop<string[]>, optionsList: any): void {
        if (event.previousContainer === event.container) {
            const currentList = optionsList.items.getRawValue();
            moveItemInArray(currentList, event.previousIndex, event.currentIndex);
            optionsList.items.patchValue(currentList);
            this.addKeywords(optionsList.items, currentList);

            // disabled items
            const disabledItemsList = optionsList.disabledItems.getRawValue();
            moveItemInArray(disabledItemsList, event.previousIndex, event.currentIndex);
            optionsList.disabledItems.patchValue(disabledItemsList);
            this.addKeywords(optionsList.disabledItems, disabledItemsList);
        }
    }

    droppedGroup(event: CdkDragDrop<string[]>, groupsList: any): void {
        if (event.previousContainer === event.container) {
            const currentList = groupsList.getRawValue();
            moveItemInArray(currentList, event.previousIndex, event.currentIndex);
            groupsList.controls.map((group, index) => {
                const groupItem = group as FormGroup;
                const options = groupItem.controls.items as FormArray;
                const optionsData = currentList[index].items;
                while (options.length !== 0) {
                    options.removeAt(0);
                }
                for (const item in optionsData) {
                    this.addOption(options);
                }
                this.addKeywords(options, optionsData);
            });
            groupsList.patchValue(currentList);
        }
    }

    addGroup(): void {
        this.menuGroups.push(MultipleChoiceNode.getGroupTemplate(this.canEdit));
        this.collapseExpandStates.push('open');
        this.optionCount = this.getOptionCount();
    }

    removeGroup(index: number,  event?): void {
        event?.stopPropagation();
        if (this.menuGroups.length === 1) {
            swalMini({title: 'At least one group needed', type: 'error'});
            return;
        }
        if (!this.canEdit.canEdit) {
            return;
        }
        const groupTitle = this.menuGroups.at(index).get('groupTitle').value;
        this.openDeleteGroupModal(groupTitle, index);
    }

    openDeleteGroupModal(groupTitle: string, index: number) {
        const dialogRef = this.dialog.open(DeleteGroupModalComponent, {
            panelClass: 'default-dialog',
            width: '528px',
            height: '249px',
            data: {groupTitle: groupTitle, index: index},
        });

        dialogRef.afterClosed().subscribe((data: {shouldDelete: string, index: number}) => {
            if (data.shouldDelete) {
                this.menuGroups.removeAt(data.index);
                this.collapseExpandStates.splice(data.index, 1);
            }
        });
    }

    setImage(event, form) {
        form.get('imageRef').setValue(event);
    }

    stopPropagationHandler(event) {
        event.stopPropagation();
    }

    moveOptionToGroup(index, from, to) {
        const groupFrom = this.menuGroups.controls[from] as FormGroup;
        const groupTo = this.menuGroups.controls[to] as FormGroup;
        const groupFromValue = groupFrom.getRawValue();
        const groupToValue = groupTo.getRawValue();
        if (groupFromValue.items) {
            const option = groupFromValue.items[index];
            groupToValue.items.push(option);
            const groupItemOptions = groupTo.controls.items as FormArray;
            while (groupItemOptions.length !== 0) {
                groupItemOptions.removeAt(0);
            }
            for (const item in groupToValue.items) {
                this.addOption(groupItemOptions);
            }
            groupItemOptions.patchValue(groupToValue.items);
            this.addKeywords(groupItemOptions, groupToValue.items);
        }

        this.removeOption(index, groupFrom.controls.items);
    }

    moveDisabledOptionToGroup(index, from, to) {
        const groupFrom = this.menuGroups.controls[from] as FormGroup;
        const groupTo = this.menuGroups.controls[to] as FormGroup;
        const groupFromValue = groupFrom.getRawValue();
        const groupToValue = groupTo.getRawValue();
        if (groupFromValue.disabledItems) {
            const option = groupFromValue.disabledItems[index];
            groupToValue.disabledItems.push(option);
            const groupItemOptions = groupTo.controls.disabledItems as FormArray;
            while (groupItemOptions.length !== 0) {
                groupItemOptions.removeAt(0);
            }
            for (const item in groupToValue.disabledItems) {
                this.addOption(groupItemOptions);
            }
            groupItemOptions.patchValue(groupToValue.disabledItems);
            this.addKeywords(groupItemOptions, groupToValue.disabledItems);
        }

        this.removeOption(index, groupFrom.controls.disabledItems, true);
    }

    disableOption(index, group, multipleGroups) {
        const groupFrom = multipleGroups ? this.menuGroups.controls[group] as FormGroup : this.menuOptions as FormGroup;
        const groupFromValue = groupFrom.getRawValue();
        if (groupFromValue.items && groupFrom.controls.disabledItems) {
            const disabledItems = groupFrom.controls.disabledItems as FormArray;
            const disabledItemsValue = disabledItems.getRawValue();
            const option = groupFromValue.items[index];
            disabledItemsValue.push(option);
            while (disabledItems.length !== 0) {
                disabledItems.removeAt(0);
            }
            for (const item in disabledItemsValue) {
                this.addOption(disabledItems);
            }
            disabledItems.patchValue(disabledItemsValue);
            this.addKeywords(disabledItems, disabledItemsValue);
        }

        this.removeOption(index, groupFrom.controls.items);
    }

    enableOption(index, group, multipleGroups) {
        const groupFrom = multipleGroups ? this.menuGroups.controls[group] as FormGroup : this.menuOptions as FormGroup;
        const groupFromValue = groupFrom.getRawValue();
        if (groupFromValue.items && groupFrom.controls.disabledItems) {
            const items = groupFrom.controls.items as FormArray;
            const itemsValue = items.getRawValue();
            const option = groupFromValue.disabledItems[index];
            itemsValue.push(option);
            while (items.length !== 0) {
                items.removeAt(0);
            }
            for (const item in itemsValue) {
                this.addOption(items);
            }
            items.patchValue(itemsValue);
            this.addKeywords(items, itemsValue);
        }

        this.removeOption(index, groupFrom.controls.disabledItems, true);
    }
}

